import { render, staticRenderFns } from "./CorehoursSlotsGridConfigure.vue?vue&type=template&id=1d02f827&scoped=true&"
import script from "./CorehoursSlotsGridConfigure.vue?vue&type=script&lang=js&"
export * from "./CorehoursSlotsGridConfigure.vue?vue&type=script&lang=js&"
import style0 from "./CorehoursSlotsGridConfigure.vue?vue&type=style&index=0&id=1d02f827&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d02f827",
  null
  
)

export default component.exports